import {
  Component,
  ChangeDetectionStrategy,
  inject,
  computed,
} from "@angular/core";
import { DashboardStateService } from "@app/services/dashboard-state.service";
import { Client } from "@app/models/dashboard.models";
import { staggerSlideIn } from "@app/animations/stagger-entrance.animation";

const DISPLAY_LIMIT = 6;

@Component({
  selector: "app-current-customers",
  templateUrl: "./current-customers.component.html",
  styleUrl: "./current-customers.component.scss",
  animations: [staggerSlideIn],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CurrentCustomersComponent {
  private readonly stateService = inject(DashboardStateService);

  readonly clients = computed<Client[]>(
    () => this.stateService.lastData()?.clients?.slice(0, DISPLAY_LIMIT) ?? [],
  );

  readonly animationTrigger = computed(() => this.clients());
}
